module.exports = __webpack_public_path__ + "img/2039bd1.png";